<template>
  <div class="register_partner_page_wrap" >
    <img src="./img/2.png" class="logo_img" />
    <img src="./img/3.png" class="register_img" />
    <div class="title" >请填写相关资料，完成注册</div>
    <div class="form_wrap" >
      <div class="form_item" >
        <div class="form_item_label" >
          名称
        </div>
        <input class="form_input" placeholder="请输入名称" v-model="form.name" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          手机号
        </div>
        <input class="form_input" placeholder="请输入手机号" type="number" v-model="form.tel" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          密码
        </div>
        <input class="form_input" placeholder="请输入密码" type="password" v-model="form.password" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          姓名
        </div>
        <input class="form_input" placeholder="请输入姓名" v-model="form.trueName" />
      </div>

      <div class="form_item" >
        <div class="form_item_label" >
          身份证号
        </div>
        <input class="form_input" placeholder="请输入身份证号"  v-model="form.idCardNo" />
      </div>

      <div class="upload_form_wrap" @click="uploadType = 'idCardHeadImgUrl'"  >
        <div class="form_item_label" >
          上传身份证照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.idCardHeadImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传身份证人像面</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.idCardHeadImgUrl" />
          </div>
        </van-uploader>
      </div>

      <div class="upload_form_wrap" @click="uploadType = 'idCardCountryImgUrl'">
        <div class="form_item_label" >
          上传身份证照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.idCardCountryImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传身份证国徽面</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.idCardCountryImgUrl" />
          </div>
        </van-uploader>
      </div>

      <div class="upload_form_wrap"  @click="uploadType = 'businessLicenseImgUrl'">
        <div class="form_item_label" >
          上传营业执照照片
        </div>

        <van-uploader :before-read="beforeUpload">
          <div class="upload_content" v-if="!form.businessLicenseImgUrl" >
            <img src="./img/4.png" class="upload_img"  />
            <div class="upload_text" >上传营业执照照片</div>
          </div>
          <div class="upload_file_content" v-else >
            <img :src="form.businessLicenseImgUrl" />
          </div>
        </van-uploader>
      </div>
    </div>
    <van-button class="submit_button" :loading="submitting" @click="handleSubmit" >提交</van-button>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  agentAdd
} from '@/api'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'

export default {
  name: 'registerPartner',
  data() {
     return {
       form: {
         parentAgentId: this.$route.query.parentAgentId,
         businessLicenseImgUrl: '',
         idCardCountryImgUrl: '',
         idCardHeadImgUrl: '',
         idCardNo: '',
         name: '',
         password: '',
         tel: '',
         trueName: ''
       },
       uploadType: '',
       submitting: false,
     }
  },
  methods: {
    handleSubmit() {
      const { form } = this
      if(!form.name) {
        Toast('请输入名称')
        return false
      }

      if(!form.tel) {
        Toast('请输入手机号')
        return false
      }

      if(!form.password) {
        Toast('请输入密码')
        return false
      }

      if(!form.trueName) {
        Toast('请输入姓名')
        return false
      }

      if(!form.idCardNo) {
        Toast('请输入姓名')
        return false
      }

      if(!form.idCardHeadImgUrl) {
        Toast('请上传身份证人像面')
        return false
      }

      if(!form.idCardCountryImgUrl) {
        Toast('请上传身份证国徽面')
        return false
      }

     /* if(!form.businessLicenseImgUrl) {
        Toast('请上传营业执照')
        return false
      }*/

      if(!this.isValidIDCard(form.idCardNo)) {
        Toast('身份证号不正确')
        return false
      }

      if(!this.isPhone(form.tel)) {
        Toast('手机号格式不正确')
        return false
      }

      this.submitting = true
      agentAdd({...form}).then(res => {
        this.submitting = false
        if(res.success) {
          this.$router.replace({
            name: 'success'
          })
        }else {
          Toast(res.msg)
        }
      })
    },
    isPhone(phone) {
      const reg = /^((\+|00)86)?1((3[\d])|(4[5,6,7,9])|(5[0-3,5-9])|(6[5-7])|(7[0-8])|(8[\d])|(9[1,8,9]))\d{8}$/;
      return reg.test(phone);
    },
    isValidIDCard(idCard) {
      // 身份证正则表达式
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(idCard);
    },
    beforeUpload(file) {
      this.$upload(file, url => {
        console.log(this.uploadType)
        this.form[this.uploadType] = url
      })
      return false
    }
  },
  mounted() {
  }
}
</script>
